import { verifyTokenApi } from "@/api/services/admin/auth";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { ResetPasswordForm } from "@/features/auth/components/ResetPasswordForm";
import { TResetPasswordQuery } from "@/features/auth/types/resetPasswordQuery";
import { AppRoutes } from "@/routes/config";
import { getQueryFromURL } from "@/utils/url";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

type TResetPasswordPageProps = {};

export const ResetPasswordPage: FC<TResetPasswordPageProps> = () => {
  const query = getQueryFromURL<TResetPasswordQuery>();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      if (!query || !query.email || !query.resetToken) {
        navigate(AppRoutes.login);
        return;
      }

      try {
        await verifyTokenApi(query.resetToken);
        setIsTokenValid(true);
      } catch {
        navigate(AppRoutes.pageNotFound);
      } finally {
        setIsVerifying(false);
      }
    };

    verifyToken();
  }, []);

  if (isVerifying) {
    return <LoadingScreen />;
  }

  if (!isTokenValid) {
    return null;
  }

  return (
    <Stack gap={4} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold">パスワード再発行</Typography>
      <Typography variant="body14" width={"100%"}>
        新しいパスワードを入力してください。
      </Typography>
      <ResetPasswordForm />
    </Stack>
  );
};
